// extracted by mini-css-extract-plugin
module.exports = {"container":"static-chat-messages_container__kKy30"};